var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReviewavatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "review_avatar"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3240",
    "data-name": "Ellipse 3240",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(1306 24)",
    fill: "#a5a2b4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "review_avatar",
    "data-name": "review avatar",
    transform: "translate(-1302 -20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3239",
    "data-name": "Ellipse 3239",
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    transform: "translate(1302 20)",
    fill: "#efeff6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_849",
    "data-name": "Mask Group 849",
    transform: "translate(6 6)",
    opacity: 0.5,
    clipPath: "url(#review_avatar)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-09-18T134021.714",
    "data-name": "svgexport-6 - 2022-09-18T134021.714",
    transform: "translate(1306 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16097",
    "data-name": "Group 16097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16096",
    "data-name": "Group 16096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28292",
    "data-name": "Path 28292",
    d: "M13,0a6.751,6.751,0,1,0,6.751,6.751A6.768,6.768,0,0,0,13,0Z",
    fill: "#a5a2b4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16099",
    "data-name": "Group 16099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16098",
    "data-name": "Group 16098"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28293",
    "data-name": "Path 28293",
    d: "M24.587,18.9a6.293,6.293,0,0,0-.678-1.238A8.391,8.391,0,0,0,18.1,14a1.243,1.243,0,0,0-.855.206,7.2,7.2,0,0,1-8.49,0A1.106,1.106,0,0,0,7.9,14a8.33,8.33,0,0,0-5.807,3.655A7.256,7.256,0,0,0,1.417,18.9a.627.627,0,0,0,.029.56,11.761,11.761,0,0,0,.8,1.179A11.2,11.2,0,0,0,3.6,22.168a17.67,17.67,0,0,0,1.356,1.179,13.443,13.443,0,0,0,16.036,0,12.961,12.961,0,0,0,1.356-1.179A13.612,13.612,0,0,0,23.7,20.635a10.335,10.335,0,0,0,.8-1.179A.5.5,0,0,0,24.587,18.9Z",
    fill: "#a5a2b4"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewavatar);
export default __webpack_public_path__ + "static/media/review avatar.26066bbf6474b8339446ca3c5c6e601b.svg";
export { ForwardRef as ReactComponent };